<swiper-container [id]="swiperId" autoplay="true" init="false" navigation="true" pagination="true">
  <ng-content></ng-content>
</swiper-container>
